(function () {
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector("cart-notification");
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);

    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute("disabled", true);
    submitButton.classList.add("loading");

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification
        .getSectionsToRender()
        .map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then((response) => response.json())
      .then((parsedState) => {
        document.querySelectorAll('.cart-notification-product').forEach(el => { // Remove bed bases
          if (!el.id.length) {
            el.parentElement.removeChild(el);
          }
        });
        this.cartNotification.renderContents(parsedState);
      })
      .then(() => {
        // Bed base?
        if (
          "baseProductJson" in window &&
          localStorage.getItem("bedBase") === "1"
        ) {
          const sizeField = document.querySelector("[name='options[Size]']");
          if (sizeField) {
            const size = sizeField.options[sizeField.selectedIndex].value;

            // Find bed base variant
            const sizeHelper = new SizeHelper(window.baseProductJson);
            const bedBaseVariantId =
              sizeHelper.getBedBaseVariantIdFromSizeTitle(size);

            if (bedBaseVariantId) {
              // Add bed base to the cart
              const body = JSON.stringify({
                id: bedBaseVariantId,
                quantity: 1,
              });
              return fetch(`${routes.cart_add_url}`, {
                ...fetchConfig("javascript"),
                body,
              })
                .then(res => res.json())
                .then(bedBaseAdded => {
                  const html = `<div class="cart-notification-product">
      
        <img class="cart-notification-product__image" src="${bedBaseAdded.featured_image.url.replace(/\.(png|jpg)/g, "_140x.$1")}" alt="" width="70" height="70" loading="lazy">
      
      <div class="cart-notification-product__info">
        <h3 class="cart-notification-product__name h4">${bedBaseAdded.title}</h3><dl><div class="cart-notification-product__option h4">
              </div></dl></div>
    </div>`;
                  document.querySelector('#cart-notification-product').insertAdjacentHTML('afterend', html);
                })
                .catch(console.error)
                .finally(() => {
                  localStorage.setItem("bedBase", "0");
                  if ("showAddBedBaseBtn" in window) {
                    window.showAddBedBaseBtn();
                  }
                });
            }
          }
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove("loading");
        submitButton.removeAttribute("disabled");
      });
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}

const cwsGallery = () => {
  const slides = document.querySelectorAll(".product__media-item");
  const isVariantStackTemplate = () =>
    document.querySelector(".filter-custom-image") !== null;

  const isDesktopStackMode = () =>
    isVariantStackTemplate() && window.matchMedia("(min-width: 750px)").matches;

  const ensureSwiperLoaded = () => {
    if (typeof Swiper !== "undefined") {
      return Promise.resolve(Swiper);
    }

    if (window.__swiperLoaderPromise) {
      return window.__swiperLoaderPromise;
    }

    const swiperBundleUrl = window.themeAssets?.swiperBundleUrl;
    if (!swiperBundleUrl) {
      return Promise.reject(new Error("Missing Swiper bundle URL"));
    }

    window.__swiperLoaderPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(
        `script[src="${swiperBundleUrl}"]`
      );

      if (existingScript) {
        if (typeof Swiper !== "undefined") {
          resolve(Swiper);
          return;
        }
        existingScript.addEventListener("load", () => resolve(Swiper), {
          once: true,
        });
        existingScript.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = swiperBundleUrl;
      script.defer = true;
      script.onload = () => resolve(Swiper);
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.__swiperLoaderPromise;
  };

  const getFullImageSource = (image) => {
    return {
      srcset:
        image?.getAttribute("data-full-srcset") || image?.getAttribute("srcset"),
      src: image?.getAttribute("data-full-src") || image?.getAttribute("src"),
    };
  };

  const getMediaIdFromImage = (image) => {
    return image
      ?.closest(".product__media-item")
      ?.querySelector(".product__media-toggle")
      ?.getAttribute("data-media-id");
  };

  const firstSlide = slides[0];
  const firstImg = firstSlide?.querySelector("img");
  const sliderSlides = Array.from(
    document.querySelectorAll(".product__media-item.slider__slide")
  );

  const isDesktopGallery = () => window.matchMedia("(min-width: 750px)").matches;

  const syncHeroImageSizesToRenderedWidth = () => {
    if (!firstImg || !isDesktopGallery() || isDesktopStackMode()) {
      return;
    }

    const renderedWidth = Math.ceil(firstImg.getBoundingClientRect().width);
    if (renderedWidth > 0) {
      firstImg.setAttribute("sizes", `${renderedWidth}px`);
    }
  };

  const promoteHeroImageToFullCandidates = () => {
    if (!firstImg || !isDesktopGallery() || isDesktopStackMode()) {
      return;
    }

    const fullSrcset = firstImg.getAttribute("data-full-srcset");
    const fullSrc = firstImg.getAttribute("data-full-src");

    if (fullSrcset) {
      firstImg.setAttribute("srcset", fullSrcset);
    }
    if (fullSrc) {
      firstImg.setAttribute("src", fullSrc);
    }
  };

  const setActiveSlide = (slide) => {
    if (!slide) {
      return;
    }

    sliderSlides.forEach((item) => item.classList.remove("active"));
    slide.classList.add("active");

    if (isDesktopStackMode()) {
      return;
    }

    if (firstImg) {
      const activeImgSource = getFullImageSource(slide.querySelector("img"));
      if (activeImgSource?.srcset) {
        firstImg.setAttribute("srcset", activeImgSource.srcset);
      }
      if (activeImgSource?.src) {
        firstImg.setAttribute("src", activeImgSource.src);
      }

      syncHeroImageSizesToRenderedWidth();
    }
  };

  const getActiveIndex = () => {
    const activeIndex = sliderSlides.findIndex((slide) =>
      slide.classList.contains("active")
    );
    return activeIndex >= 0 ? activeIndex : 0;
  };

  const hadTemplateActive = sliderSlides.some((slide) =>
    slide.classList.contains("active")
  );

  if (sliderSlides.length && !hadTemplateActive) {
    sliderSlides[0].classList.add("active");
  }

  if (!isDesktopStackMode()) {
    promoteHeroImageToFullCandidates();
    syncHeroImageSizesToRenderedWidth();
  }

  // On desktop, if a template pre-marks a thumbnail as active, immediately
  // promote its full-res source into the hero image on initial load.
  if (hadTemplateActive && isDesktopGallery() && !isDesktopStackMode()) {
    setActiveSlide(sliderSlides[getActiveIndex()]);
  }

  if (!isDesktopStackMode()) {
    const galleryResizeHandler = () => {
      syncHeroImageSizesToRenderedWidth();
    };
    window.addEventListener("resize", galleryResizeHandler);
  }

  if (slides.length > 1 && sliderSlides.length) {
    const prevSlide = document.querySelector(".prev-image");
    const nextSlide = document.querySelector(".next-image");

    nextSlide?.addEventListener("click", (e) => {
      e.preventDefault();
      const nextIndex = (getActiveIndex() + 1) % sliderSlides.length;
      setActiveSlide(sliderSlides[nextIndex]);
    });

    prevSlide?.addEventListener("click", (e) => {
      e.preventDefault();
      const prevIndex =
        (getActiveIndex() - 1 + sliderSlides.length) % sliderSlides.length;
      setActiveSlide(sliderSlides[prevIndex]);
    });
  }

  const buttons = document.querySelectorAll(".slider__slide .product__media-toggle");
  const body = document.body;
  const slider = document.querySelector(".swiper--thumbnail");
  const sliderItems = slider?.querySelector(".swiper-wrapper");

  if (!buttons.length) {
    return;
  }

  const resetPopupSlider = () => {
    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    while (sliderItems.firstChild) {
      sliderItems.removeChild(sliderItems.firstChild);
    }

    sliderItems.removeAttribute("style");
  };

  buttons.forEach((button, index) => {
    button.addEventListener("click", (el) => {
      if (isDesktopStackMode()) {
        el.preventDefault();
        el.stopPropagation();
        el.stopImmediatePropagation();
        return;
      }

      const thumbSlide = button.closest(".product__media-item.slider__slide");
      if (isDesktopGallery() && thumbSlide) {
        const heroSlide = sliderSlides[0];
        const isHeroSlide = heroSlide ? thumbSlide === heroSlide : false;
        const isActiveSlide = thumbSlide.classList.contains("active");

        // Desktop behavior: thumbnail click navigates; featured or already-active image opens overlay.
        if (!isHeroSlide && !isActiveSlide) {
          el.preventDefault();
          el.stopPropagation();
          el.stopImmediatePropagation();
          setActiveSlide(thumbSlide);
          return;
        }
      }

      el.preventDefault();

      if (!slider || !sliderItems) {
        return;
      }

      const images = document.querySelectorAll(".product__media-list img");
      const seenMediaIds = new Set();

      resetPopupSlider();

      // loop color
      
      const checkBedCustom = document.querySelector('.filter-custom-image');
      function getTextBeforeParentheses(str) {
        let match = str.match(/^[^\(]+/);
        return match ? match[0].trim() : '';
      }
  
      const loopSizeLabel = document.querySelectorAll('.form__label');
      var variantColor = '';
      loopSizeLabel.forEach( (label)=> {
        
        let clearSpace = label.textContent.replace(/\s+/g, '');
        const loopColor = label.parentNode.querySelectorAll('.custom-select__dropdown li');
        const checkBySizePage = document.querySelector('.by-size-custom');
        if ( checkBySizePage ) {
          if ( clearSpace == 'Size' ) {
            // loop size
            loopColor.forEach(function (select, index) {
              if (select.classList.contains("selected")) {
                const loopColorValue = select.getAttribute("data-value");
                variantColor = getTextBeforeParentheses(loopColorValue);
                //console.log(variantColor);
                return false;
              }
            });
          } 
        } else {
          loopColor.forEach(function (select) {
            if (select.classList.contains("selected")) {
              const loopColorValue = select.getAttribute("data-value");
              variantColor = loopColorValue.toLowerCase();
              return false;
            }
          });
        }
        
      });

      if ( checkBedCustom ) {
        var count = 0;
        const variantColors = variantColor.split(',').map(color => color.trim());
        images.forEach((image) => {
          const altText = image.getAttribute('alt') || '';
          const altTextValues = altText.split(',').map(value => value.trim());
          const matchFound = altTextValues.some(value => variantColors.includes(value));
          const dataMeta = getMediaIdFromImage(image);

          if ( matchFound && dataMeta ) {
            if (seenMediaIds.has(dataMeta)) {
              return;
            }
            seenMediaIds.add(dataMeta);
            const imgSource = getFullImageSource(image);
            const slide = document.createElement("div");
            const img = document.createElement("img");
  
            img.setAttribute("alt", "");
            img.setAttribute("srcset", imgSource.srcset);
            img.setAttribute("src", imgSource.src);
            img.setAttribute("data-media-id", dataMeta);
            img.setAttribute("data-index", count);
            slide.classList.add("swiper-slide");
  
            slide.appendChild(img);
            sliderItems.appendChild(slide);
            count++;
          }
          
        });
      } else {
        var count = 0;
        images.forEach((image) => {
          const dataMeta = getMediaIdFromImage(image);
          if (!dataMeta) {
            return;
          }

          if (seenMediaIds.has(dataMeta)) {
            return;
          }
          seenMediaIds.add(dataMeta);

          const imgSource = getFullImageSource(image);
          const slide = document.createElement("div");
          const img = document.createElement("img");

          img.setAttribute("alt", "");
          img.setAttribute("srcset", imgSource.srcset);
          img.setAttribute("src", imgSource.src);
          img.setAttribute("data-media-id", dataMeta);
          img.setAttribute("data-index", count);
          slide.classList.add("swiper-slide");

          slide.appendChild(img);
          sliderItems.appendChild(slide);
          count++;
        });
      }

      if (!sliderItems.children.length) {
        return;
      }

      const initPopupSlider = () => {
        const swiper = new Swiper(slider, {
          autoHeight: true,
          observer: true,
          observeParents: true,
          allowTouchMove: true,
          simulateTouch: true,
          followFinger: true,
          touchRatio: 1.1,
          threshold: 6,
          longSwipesRatio: 0.2,
          longSwipesMs: 250,
          resistanceRatio: 0.85,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 280,
          grabCursor: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

        const dataMediaID = button.getAttribute('data-media-id');
        const selectedImage = slider.querySelector(`.swiper-slide img[data-media-id="${dataMediaID}"]`);
        const imageIndex = selectedImage
          ? parseInt(selectedImage.getAttribute('data-index') || '0', 10)
          : 0;

        setTimeout(function(){
          swiper.slideTo(imageIndex, 0, true);
        }, 50);

        body.classList.add("tp-visible");
      };

      ensureSwiperLoaded().then(initPopupSlider).catch(console.error);
    });
  });

  const closeBtn = document.querySelector(".thumbnail-popup__close");
  
  closeBtn?.addEventListener("click", () => {
    body.classList.remove("tp-visible");
    resetPopupSlider();
  });
};

cwsGallery();

// const cwsLatitudePopup = () => {
//   const latitude = document.getElementById("latitude-product-widget");
//   const getLink = setInterval(() => {
//     const link = latitude.querySelector("a");

//     if (link !== null) {
//       const getOnClick = link.getAttribute("onclick");
//       const src = getOnClick
//         .replace(
//           "LatitudeCheckout.eventHandlers.learnMoreClickEventHandler('",
//           ""
//         )
//         .replace("')");
//       const body = document.body;
//       const popup = document.createElement("div");
//       const iframe = document.createElement("iframe");

//       popup.classList.add("latitude-popup");

//       iframe.setAttribute("src", src);

//       popup.append(iframe);
//       body.append(popup);

//       clearInterval(getLink);
//     }
//   }, 100);
// };

// cwsLatitudePopup();

})();
